import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { ArrowRight } from "lucide-react";

export default function ListsIndexPage() {
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useDocumentMeta({
    title: "Lists & guides",
    description: "Editor-curated collections of the best cafés, roasteries, and bean shops across North America.",
  });

  useEffect(() => {
    api.get("/lists")
      .then(({ data }) => setLists(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="lists-index-page" className="pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-12">
        <p className="text-xs uppercase tracking-[0.25em] text-[#786B63]">Editor-curated</p>
        <h1 className="font-serif text-4xl sm:text-5xl mt-3 leading-tight">
          Lists & guides.
        </h1>
        <p className="text-[#786B63] mt-3 max-w-2xl">
          Hand-built collections by the BrewFinder editors. Hidden gems, regional tours, and the spots we send our friends to.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10">
        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="border border-border bg-card aspect-[4/3] rounded-sm animate-pulse" />
            ))}
          </div>
        ) : lists.length === 0 ? (
          <div className="border border-border bg-card rounded-sm p-16 text-center">
            <p className="font-serif text-2xl">First list is in the works.</p>
            <p className="text-sm text-[#786B63] mt-2">Check back soon — our editors are tasting.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {lists.map((l) => (
              <Link
                key={l.slug}
                to={`/list/${l.slug}`}
                data-testid={`list-card-${l.slug}`}
                className="cafe-card group block border border-border bg-card overflow-hidden rounded-sm hover:-translate-y-1 transition-transform"
              >
                <div className="aspect-[4/3] bg-[#E8DFD3] overflow-hidden">
                  {l.hero_image_url && (
                    <img src={l.hero_image_url} alt="" className="cafe-card-image w-full h-full object-cover" />
                  )}
                </div>
                <div className="p-6">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-[#786B63]">
                    {(l.cafe_ids || []).length} cafés · by {l.author_name}
                  </p>
                  <h2 className="font-serif text-2xl mt-2 leading-tight">{l.title}</h2>
                  <p className="text-sm text-[#786B63] mt-2 line-clamp-2 leading-relaxed">{l.intro}</p>
                  <span className="inline-flex items-center gap-1 text-xs text-[#C05A46] mt-3">
                    Read the guide <ArrowRight size={12} strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
